import { createFileRoute } from '@tanstack/react-router';
import { productIdPathParams } from '@/lib/product-url-codec';
import { MarketPicker } from '@/features/vault/components/MarketPicker';

export const Route = createFileRoute('/vault_/market/$sourceType/$productId')({
  // Opaque token in the address bar, never the global product id.
  params: {
    parse: (params) => productIdPathParams.parse(params),
    stringify: (params) => productIdPathParams.stringify(params),
  },
  component: MarketPicker,
});
